import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
// slices
import patientReducer from './slices/Patient';
import examReducer from './slices/Exam';
import userReducer from './slices/User';
import messageReducer from './slices/Message';
import profileReducer from './slices/Profile';
import consultationHistoryReducer from './slices/ConsultationHistory';
import actorReducer from './slices/Actor';
import groupReducer from './slices/Groups';
import delegationReducer from './slices/Delegation';
import dictionaryReducer from './slices/Dictionary';

import allReducer from './slices/All';
import fusionReducer from './slices/Fusion';


// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: []
};

const rootReducer = combineReducers({
  patient: patientReducer,
  user: userReducer,
  message: messageReducer,
  profile: profileReducer,
  actor: actorReducer,
  consultationHistory: consultationHistoryReducer,
  exam: examReducer,
  group: groupReducer,
  fusion: fusionReducer,
  all: allReducer,
  delegation: delegationReducer,
  dictionary: dictionaryReducer

});

export { rootPersistConfig, rootReducer };
